import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    marginTop: theme.spacing(10)
  },
  titleContainer: {
    marginBottom: theme.spacing(6)
  },
  rightContainer: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  rightLabel: {
    color: theme.colorPalette.beige_75,
    display: 'inline',
    textTransform: 'uppercase'
  },
  addContainer: {
    borderRadius: 6,
    border: `2px solid ${theme.colorPalette.white_10}`,
    backgroundColor: theme.colors.white_30,
    padding: theme.spacing(3, 4, 3, 8),
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.10)'
  },
  addButton: {
    backgroundColor: theme.colorPalette.orange_10,
    color: theme.colors.white,
    borderRadius: '50%',
    width: 36,
    height: 36,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  addLabel: {
    fontSize: 16,
    fontWeight: 400,
    margin: 0,
    color: theme.colorPalette.green_20
  }
}));

export default useStyles;
